import {DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import styled, {css} from 'styled-components'

export const StyledFooter = styled(DialogFooter)(
    ({theme: {spacing}}) => css`
        justify-content: flex-end;
        gap: ${spacing * 2}px;
    `
)
